"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeautyPointsRoot = void 0;
var _mui = require("@ori-ui/mui");
const BeautyPointsRoot = exports.BeautyPointsRoot = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    fontSize,
    gap = 0
  } = {},
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontWeight: 'bold',
  gap: theme.spacing(gap),
  letterSpacing: 0,
  ...(Boolean(fontSize) && {
    fontSize: theme.typography.pxToRem(fontSize ?? 0)
  })
}));
